export const queryKeys = {
  CITY_ADMIN_VIEW: "CITY_ADMIN_VIEW",
  CITY_ORGANIZATION_SELECT: "CITY_ORGANIZATION_SELECT",
}